
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireffc5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireffc5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $3b86e6ded66ad216$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["fzFkW","index.aec731a1.js","8DD3f","arrow-dark.c266c189.svg","844Fz","arrow-down.81662970.svg","ap4eX","arrow-right.c7563f9a.svg","9wyhT","arrow-up.ac354ea9.svg","9UFqH","arrow.8397d492.svg","b44Xy","avatar.2c8b6978.png","eHWgZ","case-1.d3499120.png","7hEFG","case-2.23430c2d.png","bJ5Uv","case-3.f165a2c5.png","e8yTQ","case-4.19f308b7.png","fihuM","case-studies-vector.4e4fe3e1.svg","eUguF","check.b9e1fb0c.svg","jkNvq","copy.30df4a9b.svg","chxEn","emotional-vector.52981a5a.svg","9yor7","flag.c9cddf54.png","191li","footer-orange-vector.1193adbe.svg","kmgLW","footer-purple-vector.ac11826b.svg","l6bKv","hand.519e237c.svg","3gmYo","heart.a80f852b.svg","5jEft","human-friendly-vector.25a740a4.svg","aoBrX","new.04fc448e.svg","1NmDR","plane.332ad5c1.svg","38jsY","ui.dd428ae2.svg","4feOc","ux.1c719840.svg","4HAaX","index.38a55928.css"]'));


//# sourceMappingURL=index.runtime.1de36cd9.js.map
